module.exports = __webpack_public_path__ + "img/mall10.a392149f.png";